import Navbar from '../components/Navbar'
import Footer from '../components/Footer'
import './PrivacyPolicy.css'

export default function PrivacyPolicy() {
    return (
        <div>
            <Navbar/>
            <div id = "privacy-policy" style = {{width: '80vw', maxWidth: '1000px', marginLeft: 'auto', marginRight: 'auto', textAlign: 'left', marginTop: '100px', marginBottom: '100px'}}>
                <h1>Privacy Policy</h1><br></br>
                <p>Effective Date: 12/20/2024</p><br></br>
                <p>KC Social Nest ("we," "our," "us") 
                    is committed to protecting your privacy. 
                    This Privacy Policy explains how we collect, 
                    use, and safeguard your information when you 
                    use our chatbot service. By using KC Social 
                    Nest, you agree to the practices described in 
                    this Privacy Policy.
                </p>

                <h2>Information We Collect</h2>
                <p>
                    a. Temporary Conversation Data<br></br>
                    To provide accurate clinical resource information, 
                    KC Social Nest temporarily stores conversation data during your 
                    session. This data is essential for:
                    <ul>
                        <li>Understanding your queries.</li>
                        <li>Delivering accurate and relevant information about clinical resources.</li>
                    </ul>

                    <br></br><br></br>

                    b. External Database Access<br></br>
                    KC Social Nest connects to an external database that contains 
                    information about clinical resources. 
                    No personally identifiable information (PII) is stored in this database.

                </p>

                <h2>Data Retention</h2>
                <ul>
                    <li>Temporary Storage: Conversation data is stored temporarily and automatically deleted 30 days after the session ends.</li>
                    <li>No Permanent Storage: KC Social Nest does not store any user data permanently.</li>
                </ul>

                <h2>Third-Party Services</h2>
                <p>
                    KC Social Nest utilizes the following APIs to enhance its functionality:
                    <ul>
                        <li>OpenAI API: Used for natural language processing and understanding your queries.</li>
                        <li>Llama Index API: Used for indexing and retrieving information from the external clinical resources database.</li>
                    </ul>
                    These services process data solely to facilitate the chatbot's 
                    functionality and do not retain your information beyond what is 
                    necessary to fulfill their role.
                </p>

                <h2>How We Use Your Data</h2>
                <p>
                    The temporary conversation data is used to:
                    <ul>
                        <li>Provide you with accurate and helpful information about clinical resources.</li>
                        <li>Improve your overall user experience.</li>
                    </ul>
                    We do not sell, rent, or share your data with third parties for marketing or other purposes.
                </p>

                <h2>Data Security</h2>
                <p>
                    We implement appropriate technical and organizational measures to protect your 
                    temporary conversation data from unauthorized access, alteration, or destruction. 
                    However, no method of transmission over the internet or electronic storage is 100% secure, 
                    and we cannot guarantee absolute security.
                </p>

                <h2>User Rights</h2>
                <p>
                    You have the right to:
                    <ul>
                        <li>Access the information temporarily stored during your session.</li>
                        <li>Request the immediate deletion of your session data.</li>
                    </ul>
                    To exercise these rights, please contact us at admin@kcsocialnest.com.
                </p>

                <h2>Changes to This Privacy Policy</h2>
                <p>
                We may update this Privacy Policy from time to time to reflect changes 
                in our practices or for other operational, legal, or regulatory reasons. 
                Any changes will be effective immediately upon posting the updated Privacy Policy.
                Please review this page periodically for updates.
                </p>

                <h2>Contact Us</h2>
                <p>
                    If you have any questions about this Privacy Policy or our data practices, please contact us at: admin@kcsocialnest.com
                </p>
                <p>Thank you for using KC Social Nest.</p>
            </div>
            <Footer/>
        </div>
    )
}